import { render } from "./Sidemenu.vue?vue&type=template&id=081998de&scoped=true"
import script from "./Sidemenu.vue?vue&type=script&lang=js"
export * from "./Sidemenu.vue?vue&type=script&lang=js"

import "./Sidemenu.vue?vue&type=style&index=0&id=081998de&lang=scss&scoped=true"
import "./Sidemenu.vue?vue&type=style&index=1&id=081998de&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081998de"],['__file',"src/common/components/Sidemenu/Sidemenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "081998de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('081998de', __exports__)) {
    api.reload('081998de', __exports__)
  }
  
  module.hot.accept("./Sidemenu.vue?vue&type=template&id=081998de&scoped=true", () => {
    api.rerender('081998de', render)
  })

}


export default __exports__